import { render, staticRenderFns } from "./SocialFeedItemsView.vue?vue&type=template&id=e6c47236&scoped=true"
import script from "./SocialFeedItemsView.vue?vue&type=script&lang=ts"
export * from "./SocialFeedItemsView.vue?vue&type=script&lang=ts"
import style0 from "./SocialFeedItemsView.vue?vue&type=style&index=0&id=e6c47236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c47236",
  null
  
)

export default component.exports